import { useRoot } from "@/composables/useRoot";

export function useRoute() {
  const $root = useRoot();

  return $root.$route;
}
